import { render, staticRenderFns } from "./InvoiceOverdueNoticesList.vue?vue&type=template&id=4c66f80a&scoped=true&"
import script from "./InvoiceOverdueNoticesList.vue?vue&type=script&lang=ts&"
export * from "./InvoiceOverdueNoticesList.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceOverdueNoticesList.vue?vue&type=style&index=0&id=4c66f80a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c66f80a",
  null
  
)

export default component.exports